import { waveV3 } from '@/api/config/index.js';

export const createInvoice = async (invoice, authorization) => {
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  try {
    const response = await waveV3.post(`/users/me/invoices`, invoice, { headers });
    return { data: response?.data || [] };
  } catch (error) {
    return { data: [], error };
  }
};

export const getInvoices = async authorization => {
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  try {
    const response = await waveV3.get(`/users/me/invoices`, { headers });
    return { data: response?.data || [] };
  } catch (error) {
    return { data: [], error };
  }
};

export const updateInvoice = async (invoice, id, authorization) => {
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  try {
    const response = await waveV3.put(`/users/me/invoices/${id}`, invoice, { headers });
    return { data: response?.data || [] };
  } catch (error) {
    return { data: [], error };
  }
};

export const deleteInvoice = async (id, authorization) => {
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  try {
    const response = await waveV3.delete(`/users/me/invoices/${id}`, { headers });
    return { data: response?.data || [] };
  } catch (error) {
    return { data: [], error };
  }
};
